import { HashRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import Hemsidan from "./pages/Hemsidan";
import Kontakt from "./pages/Kontakt";
import Faq from "./pages/Faq";
import Kattfakta from "./pages/Kattfakta";
import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";

function App() {
	return (
		<HashRouter>
			<Routes>
				<Route path="/" element={<Hemsidan />} />
				<Route path="/Kontakt" element={<Kontakt />} />
				<Route path="/Faq" element={<Faq />} />
				<Route path="/Kattfakta" element={<Kattfakta />} />
			</Routes>
		</HashRouter>
	);
}

export default App;
